import type { SiteInspectionItem } from "../../../../hooks/useProjectSiteInspections";
import type { DiaryEntryItem } from "./DiaryEntryCard";
import DiaryEntryList from "./DiaryEntryList";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export interface SiteInspectionSectionProps {
  visita: SiteInspectionItem;
  entriesAsItems: DiaryEntryItem[];
  currentUserId?: string | null;
  isAdmin?: boolean;
  projectId?: string;
  onFileVisibilityChange?: () => void;
  onAddEntry: (visita: SiteInspectionItem) => void;
  onDeleteVisita?: (visita: SiteInspectionItem) => void;
  onEditEntry: (entry: DiaryEntryItem) => void;
  onDeleteEntry: (entry: DiaryEntryItem) => void;
  onUploadEntry?: (entry: DiaryEntryItem) => void;
}

export default function SiteInspectionSection({
  visita,
  entriesAsItems,
  currentUserId,
  isAdmin = false,
  projectId,
  onFileVisibilityChange,
  onAddEntry,
  onDeleteVisita,
  onEditEntry,
  onDeleteEntry,
  onUploadEntry,
}: SiteInspectionSectionProps) {
  const canDeleteVisita = isAdmin && visita.diaryEntries.length === 0;

  return (
    <Card>
      <CardContent className="p-6 pt-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-light tracking-tight text-primary-950 dark:text-white">
            {visita.displayLabel}
          </h3>
          {isAdmin && (
            <div className="flex items-center gap-2">
              {canDeleteVisita && onDeleteVisita && (
                <Button
                  type="button"
                  variant="outline"
                  className="border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 hover:border-red-400 dark:hover:border-red-600"
                  onClick={() => onDeleteVisita(visita)}
                >
                  EXCLUIR VISTA
                </Button>
              )}
              <Button
                type="button"
                variant="outline"
                className="px-4"
                onClick={() => onAddEntry(visita)}
              >
                NOVA ENTRADA
              </Button>
            </div>
          )}
        </div>
        <DiaryEntryList
          entries={entriesAsItems}
          currentUserId={currentUserId}
          isAdmin={isAdmin}
          projectId={projectId}
          onFileVisibilityChange={onFileVisibilityChange}
          onEdit={onEditEntry}
          onDelete={onDeleteEntry}
          onUpload={onUploadEntry}
        />
      </CardContent>
    </Card>
  );
}
